/**
 * Функция, которая «откладывает» вызов другой функции до того момента, когда с последнего вызова пройдёт определённое количество времени.
 * Пример: const handleChange = useCallback(debounce((value: string) => setSearch(value), 500), [])
 */
export function debounce<T>(callback: (e: T) => void, delay: number) {
  let timeout: ReturnType<typeof setTimeout>;

  return (e: T) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => callback(e), delay);
  };
}
